import { setCommonFilterToInitalState } from '@/app/globalRedux/filter/commonFilter'
import { setCompanyFiltersToInitialState } from '@/app/globalRedux/filter/companyFilter'
import { clearFilters } from '@/app/globalRedux/filter/newsFilter'
import { setProductFiltersToInitialState } from '@/app/globalRedux/filter/productFilter'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'
import { useTranslation } from '@/app/i18n/client'
import { useDispatch } from 'react-redux'
import { clearRetailCompaniesFilter } from '@/app/globalRedux/filter/retail/retailCompanyFilter'
import { clearRetailNewsFilter } from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { usePathname } from 'next/navigation'

const FreeUserClearAllFilter = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const goToPage = usePageNumberUpdator()
  const pathname = usePathname()
  const retail = pathname.includes('/retails/companies/')

  const clearFilter = () => {
    dispatch(clearFilters())
    dispatch(setCompanyFiltersToInitialState())
    dispatch(setProductFiltersToInitialState())
    dispatch(setCommonFilterToInitalState())
    goToPage({ newPageNo: 1 })
  }

  const clearRetailFilters = () => {
    dispatch(clearRetailNewsFilter())
    dispatch(clearRetailCompaniesFilter())
  }
  return (
    <>
      {retail ? (
        <span
          className="text-primary ml-auto text-[15px] items-center font-ns_bold cursor-pointer "
          onClick={() => {
            clearRetailFilters()
          }}
        >
          {t('Clear All')}
        </span>
      ) : (
        <span
          className="text-primary ml-auto text-[15px] items-center font-ns_bold cursor-pointer "
          onClick={() => {
            clearFilter()
          }}
        >
          {t('Clear All')}
        </span>
      )}
    </>
  )
}

export default FreeUserClearAllFilter
